import { useParams, Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';

interface ServiceDetail {
  title: string;
  slug: string;
  image: string;
  description: string;
  content: {
    intro: string;
    sections: Array<{
      title: string;
      content: string;
    }>;
    requirements: string[];
    process: string[];
  };
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

const servicesData: Record<string, ServiceDetail> = {
  'schengen-c-tipi-vizeler': {
    title: 'Schengen Bölgesi C Tipi Vizeler',
    slug: 'schengen-c-tipi-vizeler',
    image: 'https://public.readdy.ai/ai/img_res/2ff7a9253734a41eb9154b0e7a1bdd36.jpg',
    description: 'Schengen C Tipi vize, Avrupa\'nın 27 ülkesini kapsayan Schengen Bölgesi\'ne turistik, ticari veya aile ziyareti amaçlı kısa süreli seyahatler için düzenlenen vize türüdür.',
    content: {
      intro: 'Schengen C Tipi vizesi, 180 gün içinde maksimum 90 gün kalış süresi sağlayan kısa dönem vize türüdür. İzmir Vize Danışmanlık olarak, Schengen vize başvurularınızı en yüksek onay oranıyla sonuçlandırmak için profesyonel destek sunuyoruz.',
      sections: [
        {
          title: 'Schengen C Tipi Vize Nedir?',
          content: 'Schengen C Tipi vizesi, Avrupa Birliği üyesi ve Schengen Anlaşması\'na taraf ülkelere kısa süreli ziyaretler için verilen vize türüdür. Bu vize ile turizm, iş görüşmeleri, konferanslar, aile ziyaretleri ve kısa süreli eğitim programları gibi amaçlarla seyahat edebilirsiniz. Vize sahibi, 180 günlük süre içinde toplam 90 güne kadar Schengen Bölgesi\'nde kalabilir.'
        },
        {
          title: 'Hangi Ülkeler Schengen Bölgesi\'nde?',
          content: 'Schengen Bölgesi 27 Avrupa ülkesini kapsar: Almanya, Avusturya, Belçika, Çekya, Danimarka, Estonya, Finlandiya, Fransa, Yunanistan, Hollanda, İspanya, İsveç, İsviçre, İtalya, İzlanda, Letonya, Litvanya, Lüksemburg, Macaristan, Malta, Norveç, Polonya, Portekiz, Slovakya, Slovenya, Liechtenstein ve Hırvatistan. Tek bir Schengen vizesi ile tüm bu ülkelere seyahat edebilirsiniz.'
        },
        {
          title: 'Schengen C Tipi Vize Türleri',
          content: 'Schengen C Tipi vizesi farklı alt kategorilere ayrılır: Turistik Vize (tatil ve gezi amaçlı), Ticari Vize (iş görüşmeleri, konferans, fuar katılımı), Aile Ziyareti Vizesi (Schengen bölgesinde yaşayan aile fertlerini ziyaret), Transit Vize (havalimanı veya ülke üzerinden geçiş), Kültürel/Sportif Etkinlik Vizesi (konser, spor müsabakası vb.). Her vize türü için gerekli evraklar ve süreçler farklılık gösterebilir.'
        },
        {
          title: 'Başvuru Süreci ve Süreler',
          content: 'Schengen vize başvurusu, seyahat tarihinden en erken 6 ay, en geç 15 gün önce yapılmalıdır. Başvuru süreci ortalama 15 iş günü sürer, ancak yoğun dönemlerde bu süre 30-45 güne kadar uzayabilir. İzmir\'de başvurular VFS Global, TLScontact veya Kosmos Vize gibi aracı kuruluşlar üzerinden yapılır. Randevu alınması, evrakların teslimi, biyometrik verilerin kaydedilmesi ve ücret ödemesi sürecin temel adımlarıdır.'
        },
        {
          title: 'Vize Ücreti ve Ödeme',
          content: 'Schengen C Tipi vize ücreti yetişkinler için 80 Euro, 6-12 yaş arası çocuklar için 40 Euro\'dur. Ücret, başvuru sırasında aracı kuruma ödenir ve başvuru reddedilse bile iade edilmez. Bazı özel durumlarda (öğrenci, araştırmacı, kültürel değişim programı katılımcıları) vize ücreti muafiyeti uygulanabilir.'
        }
      ],
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'Vize başvuru formu (eksiksiz doldurulmuş)',
        'Biyometrik fotoğraf (son 6 ay içinde çekilmiş)',
        'Seyahat sağlık sigortası (minimum 30.000 Euro teminat)',
        'Uçak rezervasyonu (gidiş-dönüş)',
        'Konaklama belgesi (otel rezervasyonu veya davetiye)',
        'Mali durum belgeleri (banka hesap özeti, maaş bordrosu)',
        'İş yerinden izin belgesi veya öğrenci belgesi',
        'Medeni durum belgeleri (evlilik cüzdanı, nüfus kayıt örneği)',
        'Seyahat amacını kanıtlayan belgeler'
      ],
      process: [
        'Ön değerlendirme ve danışmanlık görüşmesi',
        'Gerekli evrakların belirlenmesi ve hazırlanması',
        'Vize başvuru formunun profesyonel şekilde doldurulması',
        'Randevu alınması ve tarih planlaması',
        'Evrakların kontrolü ve eksikliklerin giderilmesi',
        'Başvuru merkezine gidiş ve biyometrik veri kaydı',
        'Başvuru takibi ve bilgilendirme',
        'Vize sonucunun alınması ve pasaport teslimi'
      ]
    },
    faqs: [
      {
        question: 'Schengen vizesi kaç günde çıkar?',
        answer: 'Schengen vize başvuruları ortalama 15 iş günü içinde sonuçlanır. Ancak yoğun dönemlerde bu süre 30-45 güne kadar uzayabilir. Acil durumlar için hızlandırılmış başvuru seçeneği de mevcuttur.'
      },
      {
        question: 'Schengen vizesi ile hangi ülkelere gidebilirim?',
        answer: '27 Schengen ülkesine tek vize ile seyahat edebilirsiniz: Almanya, Fransa, İtalya, İspanya, Hollanda, Belçika, Avusturya, İsviçre, Yunanistan ve diğer üye ülkeler.'
      },
      {
        question: 'Schengen vizesi için hesapta ne kadar para olmalı?',
        answer: 'Günlük minimum 50-70 Euro gösterebilmeniz beklenir. Örneğin 15 günlük seyahat için yaklaşık 750-1000 Euro banka hesabınızda bulunmalıdır. Ancak bu miktar ülkeye ve seyahat süresine göre değişebilir.'
      },
      {
        question: 'Schengen vizesi reddedilirse ne yapmalıyım?',
        answer: 'Ret gerekçesi analiz edilmeli ve eksiklikler giderilmelidir. İtiraz süreci başlatılabilir veya yeni bir başvuru hazırlanabilir. İzmir Vize Danışmanlık olarak ret analizi ve yeniden başvuru süreçlerinde profesyonel destek sağlıyoruz.'
      }
    ]
  },
  'schengen-d-tipi-vizeler': {
    title: 'Schengen Bölgesi D Tipi Vizeler',
    slug: 'schengen-d-tipi-vizeler',
    image: 'https://readdy.ai/api/search-image?query=Long%20term%20residence%20permit%20card%20and%20national%20visa%20documents%20with%20European%20flag%20on%20modern%20office%20desk%20professional%20immigration%20concept%20clean%20bright%20lighting%20minimal%20white%20background&width=1200&height=600&seq=schengen-d-detail-002&orientation=landscape',
    description: 'Schengen D Tipi vize, uzun süreli kalış, çalışma, eğitim veya aile birleşimi gibi amaçlarla Avrupa ülkelerine yerleşmek isteyenler için düzenlenen ulusal vize türüdür.',
    content: {
      intro: 'D Tipi vize, 90 günden uzun süreli kalışlar için düzenlenen ulusal vize türüdür. Öğrenci vizesi, çalışma vizesi, aile birleşimi vizesi gibi farklı kategorilerde başvuru yapılabilir. İzmir Vize Danışmanlık olarak, uzun süreli vize süreçlerinizde kapsamlı destek sunuyoruz.',
      sections: [
        {
          title: 'D Tipi Vize Nedir?',
          content: 'D Tipi vize, Schengen ülkelerinde 90 günden fazla kalmak isteyenler için düzenlenen ulusal vizedir. C Tipi vizeden farklı olarak, bu vize ile belirli bir ülkede uzun süreli ikamet etme, çalışma, eğitim görme veya aile birleşimi gerçekleştirme hakkı elde edilir. Her ülkenin kendi ulusal mevzuatına göre düzenlenen D Tipi vize, genellikle oturum iznine dönüştürülebilir.'
        },
        {
          title: 'D Tipi Vize Türleri',
          content: 'D Tipi vize farklı amaçlar için düzenlenir: Öğrenci Vizesi (üniversite, dil okulu, yüksek lisans, doktora programları), Çalışma Vizesi (iş sözleşmesi olan kişiler için), Aile Birleşimi Vizesi (eş, çocuk veya ebeveyn birleşimi), Araştırmacı Vizesi (bilimsel araştırma ve akademik çalışmalar), Au Pair Vizesi (kültürel değişim programları), Serbest Meslek Vizesi (freelancer, sanatçı, yazar vb.). Her vize türü için farklı evrak ve şartlar gereklidir.'
        },
        {
          title: 'Öğrenci Vizesi Başvurusu',
          content: 'Öğrenci vizesi, Avrupa ülkelerinde üniversite, yüksek lisans, doktora veya dil eğitimi almak isteyenler için düzenlenir. Başvuru için kabul mektubu, mali yeterlilik belgesi, sağlık sigortası, konaklama kanıtı ve dil yeterliliği belgesi gereklidir. Öğrenci vizesi genellikle eğitim süresince geçerlidir ve oturum iznine dönüştürülebilir. Bazı ülkelerde öğrencilere part-time çalışma izni de verilir.'
        },
        {
          title: 'Çalışma Vizesi Süreci',
          content: 'Çalışma vizesi almak için öncelikle hedef ülkede bir işveren tarafından iş teklifi alınması gerekir. İşveren, çalışma iznini yerel makamlardan almalıdır. Ardından çalışma vizesi başvurusu yapılır. İş sözleşmesi, çalışma izni, diploma ve sertifikalar, referans mektupları, mali durum belgeleri ve sağlık sigortası gibi evraklar istenir. Çalışma vizesi süreci ülkeye göre 2-6 ay arasında değişebilir.'
        },
        {
          title: 'Aile Birleşimi Vizesi',
          content: 'Aile birleşimi vizesi, Avrupa\'da yasal olarak ikamet eden bir kişinin eşi, çocukları veya ebeveynlerinin yanına gitmesini sağlar. Başvuru için evlilik cüzdanı, nüfus kayıt belgesi, sponsor kişinin ikamet belgesi ve gelir durumu, konaklama kanıtı ve dil bilgisi belgesi gerekebilir. Aile birleşimi vizesi genellikle 1-3 yıl süreli verilir ve yenilenebilir.'
        }
      ],
      requirements: [
        'Geçerli pasaport (vize süresi + 3 ay geçerli)',
        'Ulusal vize başvuru formu',
        'Biyometrik fotoğraflar',
        'Vize amacını kanıtlayan belgeler (kabul mektubu, iş sözleşmesi, evlilik belgesi)',
        'Sağlık sigortası (tüm kalış süresi için geçerli)',
        'Mali yeterlilik belgesi (banka hesap özeti, sponsor mektubu)',
        'Konaklama kanıtı (kira sözleşmesi, yurt belgesi)',
        'Sabıka kaydı belgesi (apostilli)',
        'Sağlık raporu (bazı ülkeler için)',
        'Dil yeterlilik belgesi (gerektiğinde)'
      ],
      process: [
        'Detaylı danışmanlık ve vize türü belirleme',
        'Gerekli evrakların tam listesinin çıkarılması',
        'Evrakların toplanması ve tercüme işlemleri',
        'Apostil ve noter onayı işlemleri',
        'Vize başvuru formunun hazırlanması',
        'Randevu alınması ve başvuru tarihi planlaması',
        'Konsolosluk görüşmesine hazırlık',
        'Başvurunun yapılması ve takibi',
        'Vize sonucunun alınması ve oturum izni sürecine geçiş'
      ]
    },
    faqs: [
      {
        question: 'D Tipi vize ile ne kadar kalabilirim?',
        answer: 'D Tipi vize genellikle 1 yıl süreli verilir ve yenilenebilir. Öğrenci vizesi eğitim süresince, çalışma vizesi iş sözleşmesi süresince geçerlidir. Vize süresi dolmadan oturum izni başvurusu yapılabilir.'
      },
      {
        question: 'D Tipi vize ile çalışabilir miyim?',
        answer: 'D Tipi vize türüne bağlıdır. Çalışma vizesi ile tam zamanlı çalışabilirsiniz. Öğrenci vizesi ile part-time çalışma izni verilebilir. Aile birleşimi vizesi sahipleri de belirli şartlarda çalışma izni alabilir.'
      },
      {
        question: 'D Tipi vize başvurusu ne kadar sürer?',
        answer: 'D Tipi vize başvuruları 2-6 ay arasında sonuçlanır. Süre, ülkeye, vize türüne ve başvuru yoğunluğuna göre değişir. Evrakların eksiksiz ve doğru hazırlanması süreci hızlandırır.'
      },
      {
        question: 'D Tipi vize ücreti ne kadardır?',
        answer: 'D Tipi vize ücreti ülkeye ve vize türüne göre değişir. Genellikle 60-180 Euro arasındadır. Bazı ülkeler öğrenci vizesi için indirimli ücret uygular.'
      }
    ]
  },
  'amerika-vizesi': {
    title: 'Amerika Vizesi',
    slug: 'amerika-vizesi',
    image: 'https://readdy.ai/api/search-image?query=United%20States%20visa%20application%20documents%20with%20American%20passport%20and%20DS-160%20form%20on%20professional%20desk%20USA%20embassy%20interview%20preparation%20bright%20clean%20background%20business%20travel%20concept&width=1200&height=600&seq=usa-visa-detail-003&orientation=landscape',
    description: 'Amerika Birleşik Devletleri vizesi, turistik, ticari, eğitim veya çalışma amaçlı ABD\'ye seyahat etmek isteyenler için gerekli olan resmi izin belgesidir.',
    content: {
      intro: 'Amerika vizesi, dünya genelinde en çok talep edilen vize türlerinden biridir. B1/B2 turist vizesi, F1 öğrenci vizesi, H1B çalışma vizesi gibi farklı kategorilerde başvuru yapılabilir. İzmir Vize Danışmanlık olarak, Amerika vize sürecinizde profesyonel destek ve mülakat hazırlığı sunuyoruz.',
      sections: [
        {
          title: 'Amerika Vizesi Türleri',
          content: 'Amerika vizesi farklı amaçlar için çeşitli kategorilerde düzenlenir: B1/B2 Turist ve İş Vizesi (tatil, iş görüşmeleri, konferans), F1 Öğrenci Vizesi (üniversite, dil okulu), J1 Değişim Ziyaretçisi Vizesi (staj, araştırma programları), H1B Çalışma Vizesi (profesyonel işler), L1 Şirket İçi Transfer Vizesi, K1 Nişanlı Vizesi, O1 Olağanüstü Yetenek Vizesi. Her vize türü için farklı başvuru süreci ve gereklilikler vardır.'
        },
        {
          title: 'B1/B2 Turist Vizesi Başvurusu',
          content: 'B1/B2 vizesi, Amerika\'ya turistik veya ticari amaçlı kısa süreli seyahatler için düzenlenir. Başvuru süreci DS-160 formunun doldurulması, vize ücretinin ödenmesi, mülakat randevusu alınması ve konsolosluk görüşmesine katılım adımlarından oluşur. Mülakat sırasında seyahat amacı, mali durum, Türkiye\'ye bağlılık ve geri dönüş niyeti değerlendirilir. Vize süresi genellikle 10 yıl olup, her seyahatte maksimum 6 ay kalış izni verir.'
        },
        {
          title: 'DS-160 Formu Nasıl Doldurulur?',
          content: 'DS-160, Amerika vize başvurusu için zorunlu olan online formdur. Form İngilizce doldurulmalı ve tüm bilgiler doğru ve eksiksiz olmalıdır. Kişisel bilgiler, pasaport bilgileri, seyahat planları, iş ve eğitim geçmişi, aile bilgileri ve güvenlik soruları gibi bölümler içerir. Form doldurulduktan sonra onay sayfası yazdırılmalı ve mülakat sırasında götürülmelidir. Hatalı veya eksik form doldurma vize reddine yol açabilir.'
        },
        {
          title: 'Amerika Vize Mülakatı Hazırlığı',
          content: 'Mülakat, Amerika vize sürecinin en kritik aşamasıdır. Konsolosluk görevlisi, başvuru sahibinin seyahat amacını, mali durumunu ve Türkiye\'ye geri dönüş niyetini değerlendirir. Mülakat öncesi hazırlık çok önemlidir: Tüm evraklar düzenli şekilde hazırlanmalı, seyahat planı net olmalı, mali durum güçlü belgelerle kanıtlanmalı, Türkiye\'deki bağlar (iş, aile, mülk) vurgulanmalı, İngilizce cevaplar kısa ve net olmalıdır. İzmir Vize Danışmanlık olarak mülakat simülasyonu ve hazırlık eğitimi sunuyoruz.'
        },
        {
          title: 'Amerika Vizesi Red Nedenleri',
          content: 'Amerika vizesi red nedenleri arasında yetersiz mali durum, zayıf geri dönüş bağları, tutarsız bilgiler, önceki vize ihlalleri, eksik evraklar ve mülakatta zayıf performans yer alır. En yaygın ret nedeni INA 214(b) maddesidir ve başvuru sahibinin ABD\'de kalma niyeti taşıdığı şüphesini ifade eder. Ret durumunda yeniden başvuru yapılabilir, ancak ret nedenleri analiz edilmeli ve güçlendirilmelidir.'
        }
      ],
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'DS-160 form onay sayfası',
        'Vize ücreti ödeme makbuzu',
        'Mülakat randevu onay belgesi',
        'Biyometrik fotoğraf (5x5 cm, beyaz fon)',
        'Mali durum belgeleri (banka hesap özeti, maaş bordrosu, vergi beyannamesi)',
        'İş belgesi veya öğrenci belgesi',
        'Seyahat planı (uçak rezervasyonu, otel rezervasyonu)',
        'Davetiye mektubu (varsa)',
        'Önceki seyahat belgeleri (eski pasaportlar, vizeler)'
      ],
      process: [
        'Ön danışmanlık ve profil değerlendirmesi',
        'DS-160 formunun profesyonel şekilde doldurulması',
        'Vize ücretinin ödenmesi',
        'Mülakat randevusu alınması',
        'Gerekli evrakların hazırlanması ve kontrolü',
        'Mülakat hazırlığı ve simülasyon eğitimi',
        'Konsolosluk mülakatına katılım',
        'Vize sonucunun takibi ve pasaport teslimi'
      ]
    },
    faqs: [
      {
        question: 'Amerika vizesi kaç günde çıkar?',
        answer: 'Mülakat sonrası vize işlemi genellikle 3-10 iş günü içinde tamamlanır. Ancak bazı durumlarda ek inceleme (administrative processing) gerekebilir ve bu süreç 2-8 haftaya kadar uzayabilir.'
      },
      {
        question: 'Amerika vizesi için hesapta ne kadar para olmalı?',
        answer: 'Kesin bir miktar belirlenmemiştir, ancak seyahat süresini karşılayacak yeterli mali güç gösterilmelidir. Genellikle 5.000-10.000 USD veya üzeri banka bakiyesi olumlu değerlendirilir.'
      },
      {
        question: 'Amerika vizesi reddedilirse ne yapmalıyım?',
        answer: 'Ret nedeni analiz edilmeli, eksiklikler giderilmeli ve mali durum güçlendirilmelidir. Yeniden başvuru için bekleme süresi yoktur, ancak durumunuzda değişiklik olmadan hemen başvurmak önerilmez.'
      },
      {
        question: 'Amerika vizesi ücreti ne kadardır?',
        answer: 'B1/B2 turist vizesi ücreti 185 USD\'dir. Ücret başvuru sırasında ödenir ve ret durumunda iade edilmez.'
      }
    ]
  },
  'ingiltere-vizesi': {
    title: 'İngiltere Vizesi',
    slug: 'ingiltere-vizesi',
    image: 'https://readdy.ai/api/search-image?query=United%20Kingdom%20visa%20application%20with%20British%20passport%20and%20immigration%20documents%20on%20elegant%20office%20desk%20UK%20travel%20permit%20professional%20lighting%20clean%20minimal%20background%20London%20Big%20Ben%20subtle%20background&width=1200&height=600&seq=uk-visa-detail-004&orientation=landscape',
    description: 'İngiltere vizesi, Birleşik Krallık\'a turistik, eğitim, çalışma veya aile ziyareti amaçlı seyahat etmek isteyenler için gerekli olan resmi izin belgesidir.',
    content: {
      intro: 'İngiltere vizesi, Brexit sonrası Schengen vizesinden bağımsız olarak düzenlenmektedir. Standard Visitor Visa, Student Visa, Work Visa gibi farklı kategorilerde başvuru yapılabilir. İzmir Vize Danışmanlık olarak, İngiltere vize sürecinizde kapsamlı destek sunuyoruz.',
      sections: [
        {
          title: 'İngiltere Vize Türleri',
          content: 'İngiltere vizesi farklı amaçlar için çeşitli kategorilerde düzenlenir: Standard Visitor Visa (turizm, iş ziyareti, aile ziyareti), Student Visa (üniversite, dil okulu), Skilled Worker Visa (profesyonel çalışma), Graduate Visa (mezuniyet sonrası çalışma), Family Visa (eş, çocuk birleşimi), Business Visa (girişimci, yatırımcı). Her vize türü için farklı başvuru süreci, gereklilikler ve ücretler vardır.'
        },
        {
          title: 'Standard Visitor Visa Başvurusu',
          content: 'Standard Visitor Visa, İngiltere\'ye turistik, ticari veya aile ziyareti amaçlı kısa süreli seyahatler için düzenlenir. Maksimum 6 ay kalış süresi sağlar. Başvuru online olarak yapılır, ardından biyometrik veri kaydı için randevu alınır. Mali yeterlilik, konaklama planı, seyahat amacı ve geri dönüş niyeti değerlendirilir. Vize genellikle 2-6 yıl süreli multiple entry olarak verilir.'
        },
        {
          title: 'İngiltere Öğrenci Vizesi',
          content: 'Student Visa, İngiltere\'de üniversite, yüksek lisans, doktora veya dil eğitimi almak isteyenler için düzenlenir. Başvuru için CAS (Confirmation of Acceptance for Studies) belgesi, mali yeterlilik kanıtı, İngilizce dil yeterliliği (IELTS, TOEFL), sağlık sigortası ve konaklama belgesi gereklidir. Öğrenci vizesi eğitim süresince geçerlidir ve part-time çalışma izni verir. Mezuniyet sonrası Graduate Visa başvurusu yapılabilir.'
        },
        {
          title: 'İngiltere Çalışma Vizesi',
          content: 'Skilled Worker Visa, İngiltere\'de profesyonel bir işte çalışmak isteyenler için düzenlenir. Başvuru için İngiltere\'deki bir işverenden job offer ve sponsorluk sertifikası gereklidir. İş, UK Visas and Immigration tarafından onaylanmış sponsor listesinde olmalı ve minimum maaş şartını karşılamalıdır. İngilizce dil yeterliliği ve mali yeterlilik de değerlendirilir. Çalışma vizesi genellikle 5 yıla kadar verilir ve süresiz oturum başvurusuna olanak tanır.'
        },
        {
          title: 'İngiltere Vize Başvuru Süreci',
          content: 'İngiltere vize başvurusu tamamen online yapılır. Başvuru formu doldurulur, vize ücreti ödenir, biyometrik randevu alınır. Randevuda parmak izi ve fotoğraf kaydedilir, evraklar teslim edilir. Başvuru süresi vize türüne göre 3-12 hafta arasında değişir. Priority ve Super Priority hizmetleri ile süreç hızlandırılabilir. Başvuru sonucu email ile bildirilir ve pasaport kargo ile teslim edilir.'
        }
      ],
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'Online başvuru formu',
        'Biyometrik randevu onay belgesi',
        'Vize ücreti ödeme makbuzu',
        'Biyometrik fotoğraf',
        'Mali durum belgeleri (banka hesap özeti, maaş bordrosu)',
        'Konaklama kanıtı (otel rezervasyonu, davetiye)',
        'Seyahat planı (uçak rezervasyonu)',
        'İş belgesi veya öğrenci belgesi',
        'Sponsorluk mektubu (gerektiğinde)',
        'Sağlık sigortası (öğrenci vizesi için)'
      ],
      process: [
        'Ön danışmanlık ve vize türü belirleme',
        'Online başvuru formunun doldurulması',
        'Vize ücretinin ödenmesi',
        'Biyometrik randevu alınması',
        'Gerekli evrakların hazırlanması',
        'Evrak kontrolü ve eksikliklerin giderilmesi',
        'Biyometrik veri kaydı ve evrak teslimi',
        'Başvuru takibi',
        'Vize sonucunun alınması ve pasaport teslimi'
      ]
    },
    faqs: [
      {
        question: 'İngiltere vizesi kaç günde çıkar?',
        answer: 'Standard Visitor Visa başvuruları genellikle 3 hafta içinde sonuçlanır. Priority hizmet ile 5 iş günü, Super Priority ile 24 saat içinde sonuç alınabilir.'
      },
      {
        question: 'İngiltere vizesi ücreti ne kadardır?',
        answer: 'Standard Visitor Visa ücreti 115 GBP\'dir. Öğrenci vizesi 490 GBP, Skilled Worker Visa 719-1423 GBP arasındadır. Priority hizmetler için ek ücret ödenir.'
      },
      {
        question: 'İngiltere vizesi için hesapta ne kadar para olmalı?',
        answer: 'Seyahat süresini karşılayacak yeterli mali güç gösterilmelidir. Genellikle günlük 100-150 GBP gösterebilmeniz beklenir. Öğrenci vizesi için aylık 1.334 GBP (Londra dışı) veya 1.023 GBP (Londra) gereklidir.'
      },
      {
        question: 'İngiltere vizesi reddedilirse ne yapmalıyım?',
        answer: 'Ret gerekçesi detaylı incelenmeli, eksiklikler giderilmeli ve yeniden başvuru yapılmalıdır. Bazı durumlarda administrative review başvurusu yapılabilir.'
      }
    ]
  },
  'oturum-karti-basvurulari': {
    title: 'Oturum Kartı Başvuruları',
    slug: 'oturum-karti-basvurulari',
    image: 'https://readdy.ai/api/search-image?query=Residence%20permit%20card%20and%20immigration%20documents%20with%20house%20keys%20on%20modern%20desk%20permanent%20residency%20application%20concept%20bright%20professional%20lighting%20clean%20white%20background%20relocation%20theme&width=1200&height=600&seq=residence-permit-detail-005&orientation=landscape',
    description: 'Oturum kartı, yabancı ülkelerde yasal olarak ikamet etmek, çalışmak veya eğitim görmek isteyenler için düzenlenen resmi ikamet izni belgesidir.',
    content: {
      intro: 'Oturum kartı başvuruları, yurt dışında uzun süreli yaşamak isteyenler için önemli bir süreçtir. Kısa süreli, uzun süreli ve daimi oturum izni gibi farklı kategorilerde başvuru yapılabilir. İzmir Vize Danışmanlık olarak, oturum kartı süreçlerinizde profesyonel destek sunuyoruz.',
      sections: [
        {
          title: 'Oturum Kartı Türleri',
          content: 'Oturum kartı farklı süre ve amaçlar için çeşitli kategorilerde düzenlenir: Kısa Süreli Oturum İzni (1 yıl, yenilenebilir), Uzun Süreli Oturum İzni (2-5 yıl), Daimi Oturum İzni (süresiz), Çalışma Amaçlı Oturum İzni, Öğrenci Oturum İzni, Aile Birleşimi Oturum İzni, Yatırımcı Oturum İzni. Her ülkenin oturum izni kategorileri ve şartları farklılık gösterir.'
        },
        {
          title: 'Kısa Süreli Oturum İzni',
          content: 'Kısa süreli oturum izni, genellikle 1 yıl süreli olup yenilenebilir. Turizm, iş, eğitim veya aile ziyareti gibi amaçlarla başvuru yapılabilir. Mali yeterlilik, konaklama kanıtı, sağlık sigortası ve temiz sabıka kaydı gereklidir. Başvuru, hedef ülkenin konsolosluğuna veya göçmenlik ofisine yapılır. Kısa süreli oturum izni sahipleri, belirli şartlarda çalışma izni alabilir.'
        },
        {
          title: 'Uzun Süreli Oturum İzni',
          content: 'Uzun süreli oturum izni, 2-5 yıl arası süreyle verilir ve yenilenebilir. Çalışma, eğitim, aile birleşimi veya yatırım amaçlı başvuru yapılabilir. Dil yeterliliği, entegrasyon sınavı, mali yeterlilik ve konaklama kanıtı gibi şartlar aranır. Uzun süreli oturum izni sahipleri, genellikle tam zamanlı çalışma hakkına sahiptir. Belirli süre sonunda daimi oturum başvurusu yapılabilir.'
        },
        {
          title: 'Daimi Oturum İzni',
          content: 'Daimi oturum izni, süresiz ikamet hakkı sağlar ve genellikle 5-10 yıl yasal ikamet sonrası başvurulabilir. Dil yeterliliği, entegrasyon sınavı, temiz sabıka kaydı, mali bağımsızlık ve kesintisiz ikamet şartları aranır. Daimi oturum izni sahipleri, vatandaşlık başvurusu yapabilir. Bazı ülkelerde daimi oturum izni, vatandaşlık haklarına yakın haklar sağlar.'
        },
        {
          title: 'Oturum Kartı Başvuru Süreci',
          content: 'Oturum kartı başvurusu, hedef ülkenin göçmenlik mevzuatına göre yapılır. Başvuru formu doldurulur, gerekli evraklar hazırlanır, randevu alınır ve başvuru yapılır. Başvuru süresi ülkeye ve oturum türüne göre 1-6 ay arasında değişir. Başvuru sırasında biyometrik veri kaydı yapılır. Başvuru onaylandıktan sonra oturum kartı teslim edilir. Oturum kartı, belirli aralıklarla yenilenmelidir.'
        }
      ],
      requirements: [
        'Geçerli pasaport',
        'Oturum izni başvuru formu',
        'Biyometrik fotoğraflar',
        'Mali yeterlilik belgesi (banka hesap özeti, gelir belgesi)',
        'Konaklama kanıtı (kira sözleşmesi, tapu)',
        'Sağlık sigortası',
        'Sabıka kaydı belgesi (apostilli)',
        'Sağlık raporu',
        'Dil yeterlilik belgesi (gerektiğinde)',
        'İş sözleşmesi veya öğrenci belgesi (amaca göre)',
        'Evlilik cüzdanı (aile birleşimi için)'
      ],
      process: [
        'Ön danışmanlık ve oturum türü belirleme',
        'Gerekli evrakların tam listesinin çıkarılması',
        'Evrakların toplanması ve tercüme işlemleri',
        'Apostil ve noter onayı işlemleri',
        'Başvuru formunun hazırlanması',
        'Randevu alınması',
        'Başvurunun yapılması ve biyometrik veri kaydı',
        'Başvuru takibi',
        'Oturum kartının teslim alınması'
      ]
    },
    faqs: [
      {
        question: 'Oturum kartı başvurusu ne kadar sürer?',
        answer: 'Oturum kartı başvurusu ülkeye ve oturum türüne göre 1-6 ay arasında sonuçlanır. Bazı ülkelerde hızlandırılmış başvuru seçeneği mevcuttur.'
      },
      {
        question: 'Oturum kartı ile çalışabilir miyim?',
        answer: 'Oturum kartı türüne bağlıdır. Çalışma amaçlı oturum izni ile tam zamanlı çalışabilirsiniz. Öğrenci oturum izni ile part-time çalışma izni verilebilir.'
      },
      {
        question: 'Oturum kartı ücreti ne kadardır?',
        answer: 'Oturum kartı ücreti ülkeye ve oturum türüne göre değişir. Genellikle 100-500 Euro arasındadır. Yenileme ücretleri daha düşük olabilir.'
      },
      {
        question: 'Oturum kartı reddedilirse ne yapmalıyım?',
        answer: 'Ret gerekçesi analiz edilmeli, eksiklikler giderilmeli ve yeniden başvuru yapılmalıdır. Bazı ülkelerde itiraz süreci mevcuttur.'
      }
    ]
  },
  'gocmenlik-aile-birlesiimi': {
    title: 'Göçmenlik ve Aile Birleşimi Süreçleri',
    slug: 'gocmenlik-aile-birlesiimi',
    image: 'https://readdy.ai/api/search-image?query=Family%20reunion%20immigration%20documents%20with%20family%20photos%20and%20visa%20papers%20on%20warm%20desk%20setting%20migration%20and%20relocation%20concept%20emotional%20bright%20lighting%20clean%20background%20unity%20theme&width=1200&height=600&seq=family-reunion-detail-006&orientation=landscape',
    description: 'Göçmenlik ve aile birleşimi süreçleri, yurt dışında yaşayan aile fertlerinin bir araya gelmesini veya yeni bir ülkeye kalıcı olarak yerleşmeyi sağlayan yasal prosedürlerdir.',
    content: {
      intro: 'Aile birleşimi ve göçmenlik süreçleri, ailelerin bir araya gelmesini ve yeni bir ülkede yaşam kurmasını sağlar. Eş, çocuk, ebeveyn birleşimi gibi farklı kategorilerde başvuru yapılabilir. İzmir Vize Danışmanlık olarak, aile birleşimi süreçlerinizde kapsamlı destek sunuyoruz.',
      sections: [
        {
          title: 'Aile Birleşimi Nedir?',
          content: 'Aile birleşimi, yabancı bir ülkede yasal olarak ikamet eden bir kişinin, aile fertlerini (eş, çocuk, ebeveyn) yanına getirmesini sağlayan yasal süreçtir. Avrupa Birliği, Amerika, Kanada, Avustralya gibi birçok ülke aile birleşimi hakkı tanır. Başvuru için sponsor kişinin yasal ikamet statüsü, yeterli geliri ve konaklama imkanı olması gerekir. Aile birleşimi vizesi genellikle uzun süreli verilir ve oturum iznine dönüştürülebilir.'
        },
        {
          title: 'Eş Birleşimi Süreci',
          content: 'Eş birleşimi, yurt dışında yaşayan bir kişinin eşini yanına getirmesini sağlar. Başvuru için evlilik cüzdanı, sponsor kişinin ikamet belgesi ve gelir durumu, konaklama kanıtı ve bazı ülkelerde dil yeterliliği belgesi gereklidir. Evlilik gerçek ve sürekli olmalıdır. Bazı ülkeler minimum evlilik süresi şartı arar. Eş birleşimi vizesi genellikle 1-3 yıl süreli verilir ve yenilenebilir. Belirli süre sonunda daimi oturum başvurusu yapılabilir.'
        },
        {
          title: 'Çocuk Birleşimi Süreci',
          content: 'Çocuk birleşimi, yurt dışında yaşayan ebeveynlerin çocuklarını yanına getirmesini sağlar. 18 yaş altı çocuklar için başvuru yapılabilir. Doğum belgesi, velayet belgesi, sponsor kişinin ikamet ve gelir durumu, konaklama kanıtı gereklidir. Tek ebeveyn başvurusu yapıyorsa, diğer ebeveynin onayı gerekebilir. Çocuk birleşimi vizesi genellikle ebeveynin oturum süresi kadar verilir. 18 yaşını dolduran çocuklar için farklı prosedürler uygulanır.'
        },
        {
          title: 'Ebeveyn Birleşimi Süreci',
          content: 'Ebeveyn birleşimi, yurt dışında yaşayan çocukların ebeveynlerini yanına getirmesini sağlar. Başvuru için sponsor çocuğun vatandaşlık veya daimi oturum statüsü, yeterli geliri ve konaklama imkanı olması gerekir. Ebeveynlerin sponsor çocuğa bağımlı olduğu kanıtlanmalıdır. Bazı ülkeler yaş sınırı (genellikle 65 yaş üstü) koyar. Ebeveyn birleşimi süreci diğer aile birleşimi türlerine göre daha uzun sürebilir.'
        },
        {
          title: 'Göçmenlik Programları',
          content: 'Göçmenlik programları, kalıcı olarak yeni bir ülkeye yerleşmeyi sağlar. Nitelikli işçi göçü, yatırım göçü, aile göçü, mülteci ve sığınmacı statüsü gibi farklı kategoriler vardır. Kanada Express Entry, Avustralya SkillSelect, ABD Green Card Lottery gibi programlar mevcuttur. Başvuru için eğitim, iş deneyimi, dil yeterliliği, yaş ve uyum yeteneği gibi kriterler değerlendirilir. Göçmenlik süreci 1-3 yıl arasında sürebilir.'
        }
      ],
      requirements: [
        'Geçerli pasaport',
        'Aile birleşimi başvuru formu',
        'Evlilik cüzdanı veya doğum belgesi',
        'Sponsor kişinin ikamet belgesi',
        'Sponsor kişinin gelir belgesi (maaş bordrosu, vergi beyannamesi)',
        'Konaklama kanıtı (kira sözleşmesi, tapu)',
        'Sağlık sigortası',
        'Sabıka kaydı belgesi (apostilli)',
        'Dil yeterlilik belgesi (gerektiğinde)',
        'Aile ilişkisini kanıtlayan belgeler',
        'Biyometrik fotoğraflar'
      ],
      process: [
        'Ön danışmanlık ve uygunluk değerlendirmesi',
        'Gerekli evrakların belirlenmesi',
        'Sponsor kişinin evraklarının hazırlanması',
        'Başvuru sahibinin evraklarının toplanması',
        'Tercüme ve apostil işlemleri',
        'Başvuru formunun hazırlanması',
        'Başvurunun yapılması',
        'Biyometrik veri kaydı (gerektiğinde)',
        'Başvuru takibi',
        'Vize/oturum izninin alınması'
      ]
    },
    faqs: [
      {
        question: 'Aile birleşimi vizesi ne kadar sürede çıkar?',
        answer: 'Aile birleşimi vizesi başvuruları ülkeye göre 3-12 ay arasında sonuçlanır. Eş birleşimi genellikle daha hızlı, ebeveyn birleşimi daha uzun sürer.'
      },
      {
        question: 'Aile birleşimi için sponsor ne kadar gelire sahip olmalı?',
        answer: 'Sponsor kişinin geliri, ülkeye ve aile büyüklüğüne göre değişir. Genellikle asgari ücretin 1.5-2 katı gelir şartı aranır. Bazı ülkeler belirli bir miktar banka bakiyesi talep eder.'
      },
      {
        question: 'Aile birleşimi vizesi ile çalışabilir miyim?',
        answer: 'Evet, aile birleşimi vizesi sahipleri genellikle çalışma izni alabilir. Bazı ülkelerde otomatik çalışma hakkı verilir, bazılarında ayrı çalışma izni başvurusu gerekir.'
      },
      {
        question: 'Aile birleşimi vizesi ücreti ne kadardır?',
        answer: 'Aile birleşimi vizesi ücreti ülkeye göre değişir. Genellikle 100-500 Euro arasındadır. Bazı ülkeler çocuklar için indirimli ücret uygular.'
      }
    ]
  },
  'kapi-vizeleri': {
    title: 'Kapı Vizeleri',
    slug: 'kapi-vizeleri',
    image: 'https://readdy.ai/api/search-image?query=Airport%20visa%20on%20arrival%20counter%20with%20passport%20control%20documents%20and%20boarding%20pass%20international%20terminal%20bright%20modern%20setting%20clean%20professional%20background%20border%20crossing%20concept&width=1200&height=600&seq=visa-on-arrival-detail-007&orientation=landscape',
    description: 'Kapı vizesi, havalimanı veya kara sınır kapısında, varış anında alınabilen vize türüdür. Önceden başvuru gerektirmez ve hızlı işlem sağlar.',
    content: {
      intro: 'Kapı vizesi, belirli ülkelere seyahat ederken havalimanında veya sınır kapısında doğrudan alınabilen vize türüdür. Önceden konsolosluk başvurusu gerektirmez ve pratik bir çözüm sunar. İzmir Vize Danışmanlık olarak, kapı vizesi süreçlerinde bilgilendirme ve evrak hazırlığı desteği sunuyoruz.',
      sections: [
        {
          title: 'Kapı Vizesi Nedir?',
          content: 'Kapı vizesi (Visa on Arrival), belirli ülkelere giriş yaparken havalimanı veya kara sınır kapısında doğrudan alınan vize türüdür. Önceden konsolosluk başvurusu veya randevu gerektirmez. Pasaport kontrolünde vize ücreti ödenir ve vize damgası basılır. Kapı vizesi genellikle turistik amaçlı kısa süreli kalışlar için verilir. Süre 15-90 gün arasında değişir. Bazı ülkeler sadece belirli milliyetlere kapı vizesi verir.'
        },
        {
          title: 'Hangi Ülkeler Kapı Vizesi Veriyor?',
          content: 'Türk vatandaşlarına kapı vizesi veren ülkeler arasında Mısır, Ürdün, Kenya, Tanzanya, Madagaskar, Kamboçya, Laos, Maldivler, Sri Lanka, Nepal, Endonezya (bazı havalimanları), Bolivya, Zimbabve gibi ülkeler bulunur. Her ülkenin kapı vizesi şartları, ücretleri ve süreleri farklıdır. Bazı ülkeler online ön başvuru (e-visa) sistemine geçmiştir. Seyahat öncesi güncel bilgi almak önemlidir.'
        },
        {
          title: 'Kapı Vizesi Başvuru Süreci',
          content: 'Kapı vizesi başvurusu çok basittir: Havalimanına vardığınızda "Visa on Arrival" veya "Visa" tabelasını takip edin. Pasaportunuzu, dönüş biletinizi, otel rezervasyonunuzu ve gerekli ücreti hazırlayın. Vize görevlisine evraklarınızı verin. Vize ücreti nakit olarak (genellikle USD veya Euro) ödenir. Pasaportunuza vize damgası basılır. Pasaport kontrolünden geçin. Süreç genellikle 10-30 dakika sürer.'
        },
        {
          title: 'Kapı Vizesi Gereksinimleri',
          content: 'Kapı vizesi için genel gereksinimler: Geçerli pasaport (en az 6 ay süreli), Dönüş bileti veya devam bileti, Otel rezervasyonu veya davetiye mektubu, Yeterli mali kaynak (nakit veya kredi kartı), Biyometrik fotoğraf (bazı ülkeler için), Vize ücreti (nakit USD veya Euro). Bazı ülkeler ek belgeler (sağlık sigortası, davetiye mektubu) talep edebilir. Seyahat öncesi ilgili ülkenin resmi web sitesinden güncel bilgi alınmalıdır.'
        },
        {
          title: 'Kapı Vizesi Avantaj ve Dezavantajları',
          content: 'Avantajlar: Önceden konsolosluk başvurusu gerektirmez, Hızlı ve pratik işlem, Randevu bekleme süresi yok, Spontane seyahat planları için uygun. Dezavantajlar: Havalimanında bekleme süresi olabilir, Nakit ödeme gerekebilir, Ret riski vardır (nadiren), Bazı ülkelerde uzun kuyruklar oluşabilir, Evrak eksikliği durumunda geri gönderilme riski. Kapı vizesi almadan önce tüm gereksinimleri kontrol etmek önemlidir.'
        }
      ],
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'Dönüş bileti veya devam bileti',
        'Otel rezervasyonu veya davetiye mektubu',
        'Vize ücreti (nakit USD veya Euro)',
        'Biyometrik fotoğraf (bazı ülkeler için)',
        'Mali yeterlilik kanıtı (nakit, kredi kartı)',
        'Sağlık sigortası (bazı ülkeler için)',
        'Sarı humma aşı kartı (Afrika ülkeleri için)'
      ],
      process: [
        'Seyahat edilecek ülkenin kapı vizesi şartlarını öğrenme',
        'Gerekli evrakların hazırlanması',
        'Vize ücretinin nakit olarak hazırlanması',
        'Havalimanına varış',
        'Visa on Arrival tabelasını takip etme',
        'Evrakların vize görevlisine teslimi',
        'Vize ücretinin ödenmesi',
        'Pasaporta vize damgası basılması',
        'Pasaport kontrolünden geçiş'
      ]
    },
    faqs: [
      {
        question: 'Kapı vizesi ne kadar sürer?',
        answer: 'Kapı vizesi işlemi genellikle 10-30 dakika sürer. Ancak yoğun dönemlerde kuyruk nedeniyle 1-2 saat bekleyebilirsiniz.'
      },
      {
        question: 'Kapı vizesi ücreti ne kadardır?',
        answer: 'Kapı vizesi ücreti ülkeye göre değişir. Genellikle 20-100 USD arasındadır. Ödeme nakit olarak (USD veya Euro) yapılır.'
      },
      {
        question: 'Kapı vizesi reddedilir mi?',
        answer: 'Nadiren reddedilir, ancak evrak eksikliği, yetersiz mali durum veya güvenlik nedenleriyle ret olabilir. Tüm gereksinimleri karşılamak önemlidir.'
      },
      {
        question: 'Kapı vizesi ile ne kadar kalabilirim?',
        answer: 'Kapı vizesi süresi ülkeye göre değişir. Genellikle 15-90 gün arasındadır. Bazı ülkelerde uzatma imkanı vardır.'
      }
    ]
  },
  'e-vizeler': {
    title: 'E-Vizeler',
    slug: 'e-vizeler',
    image: 'https://readdy.ai/api/search-image?query=Electronic%20visa%20application%20on%20smartphone%20and%20laptop%20screen%20with%20digital%20passport%20online%20e-visa%20system%20modern%20technology%20bright%20clean%20background%20digital%20travel%20authorization%20concept&width=1200&height=600&seq=e-visa-detail-008&orientation=landscape',
    description: 'E-vize, elektronik vize sistemi ile online olarak başvurulan ve dijital ortamda onaylanan vize türüdür. Konsolosluk ziyareti gerektirmez.',
    content: {
      intro: 'E-vize (elektronik vize), internet üzerinden başvurulan ve dijital ortamda onaylanan modern vize türüdür. Konsolosluk ziyareti, randevu veya fiziksel evrak teslimi gerektirmez. İzmir Vize Danışmanlık olarak, e-vize başvurularınızda profesyonel destek sunuyoruz.',
      sections: [
        {
          title: 'E-Vize Nedir?',
          content: 'E-vize, elektronik vize sistemi ile online olarak başvurulan ve dijital ortamda onaylanan vize türüdür. Başvuru tamamen internet üzerinden yapılır, evraklar dijital olarak yüklenir, ödeme online gerçekleştirilir ve vize onayı email ile gönderilir. E-vize sistemi, vize sürecini hızlandırır ve kolaylaştırır. Onaylanan e-vize yazdırılarak seyahatte yanınızda taşınır. Bazı ülkeler tamamen e-vize sistemine geçmiştir.'
        },
        {
          title: 'Hangi Ülkeler E-Vize Veriyor?',
          content: 'Türk vatandaşlarına e-vize veren ülkeler arasında Türkiye (yabancılar için), Hindistan, Avustralya (ETA), Yeni Zelanda (NZeTA), Kanada (eTA), Sri Lanka, Myanmar, Vietnam, Kamboçya, Kenya, Tanzanya, Zimbabve, Azerbaycan, Gürcistan, Umman, Bahreyn, Suudi Arabistan, BAE gibi ülkeler bulunur. Her ülkenin e-vize sistemi, şartları ve ücretleri farklıdır. E-vize genellikle turistik amaçlı kısa süreli kalışlar için verilir.'
        },
        {
          title: 'E-Vize Başvuru Süreci',
          content: 'E-vize başvurusu çok basittir: İlgili ülkenin resmi e-vize web sitesine girin. Online başvuru formunu doldurun (kişisel bilgiler, pasaport bilgileri, seyahat planı). Gerekli evrakları dijital olarak yükleyin (pasaport fotokopisi, fotoğraf, uçak bileti). Vize ücretini kredi kartı ile online ödeyin. Başvurunuzu gönderin. Email ile onay bekleyin (genellikle 1-7 gün). Onaylanan e-vizeyi yazdırın. Seyahatte yanınızda taşıyın.'
        },
        {
          title: 'E-Vize Gereksinimleri',
          content: 'E-vize için genel gereksinimler: Geçerli pasaport (en az 6 ay süreli), Dijital pasaport fotokopisi (renkli tarama), Dijital biyometrik fotoğraf, Kredi kartı (vize ücreti ödemesi için), Email adresi (onay için), Uçak rezervasyonu (bazı ülkeler için), Otel rezervasyonu (bazı ülkeler için). Bazı ülkeler ek belgeler (davetiye mektubu, sağlık sigortası) talep edebilir. Tüm bilgiler doğru ve eksiksiz olmalıdır.'
        },
        {
          title: 'E-Vize Avantajları',
          content: 'E-vize sisteminin avantajları: Konsolosluk ziyareti gerektirmez, Randevu bekleme süresi yok, 7/24 online başvuru imkanı, Hızlı işlem süresi (1-7 gün), Evrak gönderme masrafı yok, Kolay ve kullanıcı dostu arayüz, Online ödeme kolaylığı, Email ile anında onay. E-vize, özellikle acil seyahatler ve spontane planlar için idealdir. Ancak başvuru sırasında dikkatli olmak ve tüm bilgileri doğru girmek önemlidir.'
        }
      ],
      requirements: [
        'Geçerli pasaport (en az 6 ay süreli)',
        'Dijital pasaport fotokopisi (renkli tarama)',
        'Dijital biyometrik fotoğraf',
        'Kredi kartı (Visa, Mastercard)',
        'Email adresi',
        'Uçak rezervasyonu (bazı ülkeler için)',
        'Otel rezervasyonu (bazı ülkeler için)',
        'Davetiye mektubu (iş vizesi için)'
      ],
      process: [
        'İlgili ülkenin resmi e-vize web sitesine giriş',
        'Online başvuru formunun doldurulması',
        'Dijital evrakların yüklenmesi',
        'Bilgilerin kontrolü ve onaylanması',
        'Vize ücretinin online ödenmesi',
        'Başvurunun gönderilmesi',
        'Email ile onay bekleme (1-7 gün)',
        'Onaylanan e-vizenin yazdırılması',
        'Seyahatte e-vizenin yanında taşınması'
      ]
    },
    faqs: [
      {
        question: 'E-vize ne kadar sürede çıkar?',
        answer: 'E-vize başvuruları genellikle 1-7 gün içinde sonuçlanır. Bazı ülkeler 24-72 saat içinde onay verir. Acil durumlar için hızlandırılmış işlem seçeneği sunulabilir.'
      },
      {
        question: 'E-vize ücreti ne kadardır?',
        answer: 'E-vize ücreti ülkeye göre değişir. Genellikle 20-100 USD arasındadır. Ödeme online kredi kartı ile yapılır.'
      },
      {
        question: 'E-vize reddedilir mi?',
        answer: 'Evet, evrak eksikliği, yanlış bilgi, güvenlik nedenleri veya uygunluk şartlarını karşılamama durumunda reddedilebilir. Ret durumunda ücret iade edilmez.'
      },
      {
        question: 'E-vize ile ne kadar kalabilirim?',
        answer: 'E-vize süresi ülkeye göre değişir. Genellikle 30-90 gün arasındadır. Bazı ülkeler multiple entry e-vize verir.'
      }
    ]
  },
  'ozel-danismanlik': {
    title: 'Özel Danışmanlık Hizmetleri',
    slug: 'ozel-danismanlik',
    image: 'https://readdy.ai/api/search-image?query=VIP%20visa%20consultation%20service%20with%20professional%20consultant%20and%20client%20meeting%20in%20modern%20office%20premium%20immigration%20advisory%20elegant%20setting%20bright%20lighting%20clean%20background%20personalized%20service%20concept&width=1200&height=600&seq=vip-consultation-detail-009&orientation=landscape',
    description: 'Özel danışmanlık hizmetleri, karmaşık vize başvuruları, vize reddi analizi, itiraz süreçleri ve VIP hizmet paketleri için kişiye özel profesyonel destek sunar.',
    content: {
      intro: 'Özel danışmanlık hizmetleri, standart vize süreçlerinin ötesinde, karmaşık durumlar, vize redleri, itiraz süreçleri ve VIP hizmet talepleri için kişiye özel çözümler sunar. İzmir Vize Danışmanlık olarak, her danışanın özel durumunu detaylı analiz eder ve en uygun çözümü üretiriz.',
      sections: [
        {
          title: 'Özel Danışmanlık Nedir?',
          content: 'Özel danışmanlık, standart vize başvurularının ötesinde, karmaşık durumlar için kişiye özel çözümler üreten profesyonel hizmettir. Vize reddi analizi, itiraz süreçleri, karmaşık evrak durumları, özel gereksinimler, acil başvurular ve VIP hizmet paketleri bu kapsamdadır. Her danışanın durumu detaylı incelenir, risk analizi yapılır ve en yüksek onay şansını sağlayacak strateji belirlenir. Birebir danışman ataması ile süreç baştan sona takip edilir.'
        },
        {
          title: 'Vize Reddi Analizi ve Çözüm',
          content: 'Vize reddi, hayal kırıklığı yaratsa da son değildir. Özel danışmanlık hizmetimizle ret nedenleri detaylı analiz edilir: Ret mektubu incelenir, Eksiklikler tespit edilir, Mali durum güçlendirilir, Evraklar yeniden düzenlenir, Geri dönüş bağları güçlendirilir, Yeni başvuru stratejisi oluşturulur. Ret nedeni INA 214(b) (ABD), yetersiz mali durum, zayıf bağlar veya evrak eksikliği olabilir. Her ret nedeni için özel çözüm üretilir ve yeniden başvuru süreci profesyonelce yönetilir.'
        },
        {
          title: 'İtiraz Süreçleri',
          content: 'Bazı ülkelerde vize reddi sonrası itiraz hakkı vardır. İtiraz süreci karmaşık ve teknik bilgi gerektirir: Ret gerekçesi hukuki açıdan incelenir, İtiraz dilekçesi hazırlanır, Ek belgeler ve kanıtlar sunulur, Yasal prosedürler takip edilir, İtiraz süreci takip edilir. İngiltere Administrative Review, Schengen ülkeleri itiraz prosedürleri, Kanada reconsideration gibi süreçlerde profesyonel destek sunuyoruz. İtiraz başarı oranı, ret nedenine ve sunulan ek belgelere bağlıdır.'
        },
        {
          title: 'Karmaşık Başvurular',
          content: 'Bazı vize başvuruları standart süreçlerden daha karmaşıktır: Önceki vize ihlali geçmişi, Sabıka kaydı, Karmaşık mali durum, Serbest meslek sahipleri, Çok uluslu şirket çalışanları, Akademisyenler ve araştırmacılar, Sanatçılar ve sporcular. Bu durumlarda özel evrak hazırlığı, detaylı açıklama mektupları, ek belgeler ve profesyonel sunum gerekir. Özel danışmanlık hizmetimizle, karmaşık durumlar başarıyla yönetilir ve onay şansı maksimize edilir.'
        },
        {
          title: 'VIP Hizmet Paketi',
          content: 'VIP hizmet paketi, vize sürecinin en konforlu ve hızlı şekilde yönetilmesini sağlar: Özel danışman ataması, Öncelikli randevu alma, Evrakların toplanması ve hazırlanması, Tüm işlemlerin sizin adınıza yapılması, Konsolosluk/vize merkezine eşlik, Mülakat hazırlığı ve simülasyon, 7/24 iletişim desteği, Hızlandırılmış işlem (mümkünse), Pasaport teslim alma. VIP hizmet, özellikle yoğun iş temposu olan, zamana değer veren ve en yüksek hizmet kalitesi isteyen danışanlar için idealdir.'
        }
      ],
      requirements: [
        'Geçerli pasaport',
        'Önceki vize başvuru evrakları (varsa)',
        'Ret mektubu (vize reddi durumunda)',
        'Mali durum belgeleri',
        'İş ve eğitim belgeleri',
        'Seyahat geçmişi belgeleri',
        'Özel durum belgeleri (sabıka, sağlık raporu vb.)',
        'Tüm ilgili evraklar'
      ],
      process: [
        'Detaylı ön görüşme ve durum analizi',
        'Evrakların incelenmesi ve risk değerlendirmesi',
        'Özel strateji ve çözüm planı oluşturma',
        'Eksikliklerin belirlenmesi ve güçlendirme önerileri',
        'Evrakların profesyonel şekilde hazırlanması',
        'Başvuru sürecinin yönetilmesi',
        'Mülakat hazırlığı (gerektiğinde)',
        'Başvuru takibi ve bilgilendirme',
        'Sonuç alınması ve gerektiğinde itiraz süreci'
      ]
    },
    faqs: [
      {
        question: 'Vize reddinden sonra ne kadar beklemeliyim?',
        answer: 'Çoğu ülke için bekleme süresi yoktur, ancak durumunuzda iyileştirme yapmadan hemen başvurmak önerilmez. Ret nedenleri giderilmeli ve güçlü bir başvuru hazırlanmalıdır.'
      },
      {
        question: 'İtiraz süreci ne kadar sürer?',
        answer: 'İtiraz süreci ülkeye göre değişir. Genellikle 2-8 hafta arasında sonuçlanır. Bazı ülkelerde daha uzun sürebilir.'
      },
      {
        question: 'VIP hizmet paketi ne kadar sürede sonuçlanır?',
        answer: 'VIP hizmet paketi ile süreç hızlandırılır. Randevu alma, evrak hazırlığı ve başvuru süreci öncelikli olarak yönetilir. Ancak konsolosluk işlem süresi değişmez.'
      },
      {
        question: 'Özel danışmanlık ücreti ne kadardır?',
        answer: 'Özel danışmanlık ücreti, hizmet kapsamına ve başvuru karmaşıklığına göre değişir. Detaylı bilgi için bizimle iletişime geçebilirsiniz.'
      }
    ]
  }
};

export default function ServiceDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const service = slug ? servicesData[slug] : null;

  if (!service) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <h1 className="font-heading font-bold text-3xl text-darkBlue mb-4">Hizmet Bulunamadı</h1>
          <Link to="/hizmetler" className="text-secondary hover:underline">
            Hizmetler sayfasına dön
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-96 overflow-hidden">
        <img 
          src={service.image} 
          alt={service.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-darkBlue/90 to-darkBlue/70 flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl text-white mb-4">
              {service.title}
            </h1>
            <p className="font-body text-xl text-white/90 max-w-3xl">
              {service.description}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <p className="font-body text-lg text-gray-700 leading-relaxed mb-8">
              {service.content.intro}
            </p>

            {service.content.sections.map((section, index) => (
              <div key={index} className="mb-12">
                <h2 className="font-heading font-bold text-2xl text-darkBlue mb-4">
                  {section.title}
                </h2>
                <p className="font-body text-gray-700 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Requirements Section */}
      <section className="py-20 bg-lightBlue">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl text-darkBlue mb-8 text-center">
            Gerekli Evraklar
          </h2>
          <div className="bg-white rounded-2xl p-8 shadow-md">
            <ul className="space-y-3">
              {service.content.requirements.map((req, index) => (
                <li key={index} className="flex items-start space-x-3 font-body text-gray-700">
                  <i className="ri-checkbox-circle-fill text-secondary mt-1 flex-shrink-0"></i>
                  <span>{req}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl text-darkBlue mb-8 text-center">
            Başvuru Süreci
          </h2>
          <div className="space-y-4">
            {service.content.process.map((step, index) => (
              <div key={index} className="bg-lightBlue rounded-xl p-6 flex items-start space-x-4">
                <div className="flex-shrink-0 w-10 h-10 bg-secondary rounded-full flex items-center justify-center text-white font-bold">
                  {index + 1}
                </div>
                <p className="font-body text-gray-700 pt-2">{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-lightBlue">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl text-darkBlue mb-12 text-center">
            Sıkça Sorulan Sorular
          </h2>
          <div className="space-y-6">
            {service.faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md">
                <h4 className="font-heading font-bold text-lg text-darkBlue mb-3">
                  {faq.question}
                </h4>
                <p className="font-body text-gray-600">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-secondary to-orange-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-white mb-4">
            {service.title} İçin Hemen Başvurun
          </h2>
          <p className="font-body text-lg text-white/90 mb-8">
            Profesyonel danışmanlık ve %98 başarı oranı ile vize sürecinizi güvenle yönetin
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/iletisim"
              className="bg-white hover:bg-gray-100 text-secondary px-8 py-4 rounded-full font-body font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Ücretsiz Danışmanlık
            </Link>
            <a
              href="tel:+905422671171"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border-2 border-white px-8 py-4 rounded-full font-body font-bold transition-all whitespace-nowrap"
            >
              +90 542 267 11 71
            </a>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl text-darkBlue mb-8 text-center">
            Diğer Hizmetlerimiz
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {Object.values(servicesData)
              .filter(s => s.slug !== slug)
              .slice(0, 3)
              .map((relatedService, index) => (
                <Link
                  key={index}
                  to={`/hizmetler/${relatedService.slug}`}
                  className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all"
                >
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={relatedService.image} 
                      alt={relatedService.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading font-bold text-lg text-darkBlue group-hover:text-secondary transition-colors mb-2">
                      {relatedService.title}
                    </h3>
                    <p className="font-body text-sm text-gray-600">
                      {relatedService.description}
                    </p>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
